import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs, isDefined } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import useUiModeClassName from '../../hooks/useUiModeClassName.js';
import TableHeader from './TableHeader/index.js';
import TableRow from './TableRow/index.js';
import TableData from './TableData/index.js';
import styles from './styles.css.js';

const tableVariantToStyleMap = {
  regular: styles.regular,
  small: styles.small,
  large: styles.large
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function Table(props) {
  const {
    data,
    keySelector,
    columns,
    caption,
    className,
    captionClassName,
    headerRowClassName,
    headerCellClassName,
    rowClassName,
    cellClassName,
    uiMode,
    variant = 'regular',
    rowModifier
  } = props;
  const themeClassName = useUiModeClassName(uiMode, styles.light, styles.dark);
  return /*#__PURE__*/React.createElement("table", {
    className: _cs(styles.table, tableVariantToStyleMap[variant], themeClassName, className)
  }, caption && /*#__PURE__*/React.createElement("caption", {
    className: captionClassName
  }, caption), /*#__PURE__*/React.createElement("colgroup", null, columns.map(column => {
    const {
      id,
      columnClassName,
      columnStyle,
      columnWidth
    } = column;
    const style = { ...columnStyle,
      width: isDefined(columnWidth) ? columnWidth : columnStyle === null || columnStyle === void 0 ? void 0 : columnStyle.width
    };
    return /*#__PURE__*/React.createElement("col", {
      style: style,
      key: id,
      className: columnClassName
    });
  })), /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(TableRow, {
    className: _cs(styles.headerRow, headerRowClassName)
  }, columns.map((column, index) => {
    const {
      id,
      title,
      headerCellRenderer: Renderer,
      headerCellRendererClassName,
      cellAsHeader,
      headerCellRendererParams,
      headerContainerClassName
    } = column;
    const children = /*#__PURE__*/React.createElement(Renderer, _extends({}, headerCellRendererParams, {
      name: id,
      title: title,
      index: index,
      className: _cs(headerCellRendererClassName, styles.headerComponent)
    }));
    return /*#__PURE__*/React.createElement(TableHeader, {
      key: id,
      scope: "col",
      className: _cs(styles.headerCell, cellAsHeader && styles.stickLeft, headerCellClassName, headerContainerClassName)
    }, children);
  }))), /*#__PURE__*/React.createElement("tbody", null, data === null || data === void 0 ? void 0 : data.map((datum, index) => {
    const key = keySelector(datum, index);
    const cells = columns.map(column => {
      const {
        id,
        cellRenderer: Renderer,
        cellRendererClassName,
        cellRendererParams,
        cellAsHeader,
        cellContainerClassName
      } = column;
      const otherProps = cellRendererParams(key, datum, index);
      const children = /*#__PURE__*/React.createElement(Renderer, _extends({}, otherProps, {
        className: _cs(cellRendererClassName, styles.cellComponent)
      }));

      if (cellAsHeader) {
        return /*#__PURE__*/React.createElement(TableHeader, {
          key: id,
          className: _cs(styles.rowHeaderCell, cellClassName, cellContainerClassName),
          scope: "row"
        }, children);
      }

      return /*#__PURE__*/React.createElement(TableData, {
        key: id,
        className: _cs(styles.cell, cellClassName, cellContainerClassName)
      }, children);
    });
    const row = /*#__PURE__*/React.createElement(TableRow, {
      key: key,
      className: _cs(styles.row, rowClassName)
    }, cells);
    let modifiedRow = row;

    if (rowModifier) {
      modifiedRow = rowModifier({
        rowKey: key,
        row,
        cells,
        columns,
        datum
      });
    }

    return modifiedRow;
  })));
}

var Table$1 = genericMemo(Table);

export { Table$1 as default };
//# sourceMappingURL=index.js.map
